import React, { Component } from 'react'
import { Routes, Route } from 'react-router-dom'

import endPoints from '../../components/Consts/endPoints.json'

import { BeslenmeCategory, BeslenmeCategoryForm } from '../../views/BeslenmeCategory'

export default class BeslenmeCategoryRoute extends Component {
  render() {
    var releatedRoutes = endPoints.find(aa => aa.name == 'BeslenmeCategory')?.routes
    return (
      <Routes>
        <Route path={releatedRoutes?.get} exact element={<BeslenmeCategory />} />
        <Route path={releatedRoutes?.create} exact element={<BeslenmeCategoryForm />} />
        <Route path={releatedRoutes?.update} exact element={<BeslenmeCategoryForm />} />
      </Routes>
    )
  }
}
